import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=130ff53a&scoped=true&"
import script from "./index.page.vue?vue&type=script&lang=js&"
export * from "./index.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ff53a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130ff53a')) {
      api.createRecord('130ff53a', component.options)
    } else {
      api.reload('130ff53a', component.options)
    }
    module.hot.accept("./index.page.vue?vue&type=template&id=130ff53a&scoped=true&", function () {
      api.rerender('130ff53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/returnShop/index.page.vue"
export default component.exports